export default "__VITE_ASSET__CvVcMDeI__"